import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/users`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/users/${id}`
  });
}
function create(params) {
  return request({
    method: "post",
    url: `/users`,
    data: { user: params },
  });
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/users/${id}`,
    data: { user: params },
  });
}

function allUsers(params) {
  return request({
    method: "get",
    url: `/users/all_users`,
    params: params
  })
}

function isAuthenticated() {
  return request({
    method: "get",
    url: `/is_authenticated`
  })
}

function getAvailabilitySchedules(begin, end, filter) {
  const params = { begin: begin, end: end }
  for (var key in filter) { params['filter_' + key] = filter[key] }
  return request({
    method: "get",
    url: `/users/availability_schedules`,
    params: params
  });
}

const UsersService = {
  index,
  isAuthenticated,
  allUsers,
  create,
  update,
  get,
  getAvailabilitySchedules,
};

export default UsersService;
